import { useWallet } from "@solana/wallet-adapter-react"
import AdminMain from "./components/AdminMain/AdminMain"
import DashboardHeader from "./components/dashboardHeader/DashboardHeader"
import DashboardLayout from "./DashboardLayout"

export default  function AdminDashboard () {
const {publicKey} = useWallet()
const admin = process.env.REACT_APP_ADDRESS
    return (
 <DashboardLayout>


 <DashboardHeader/>

{
publicKey?.toBase58() == admin ?
 <AdminMain/>
 :
<div>

 <h1 className="Heading-large">
Page Not Found
 </h1>
</div>
               
}
           
  </DashboardLayout>   
  
)

}